import { PartialInterval } from '@interfaces/Interval';

const sortTimeFrames = ({ start }: PartialInterval, { start: startB }: PartialInterval) => {
	if (start < startB) { return -1; }
	if (start > startB) { return 1; }
	return 0;
};

export default sortTimeFrames;
